// extracted by mini-css-extract-plugin
export const sectionHeaderContainer = "downloads-module--section-header-container--2MdZI";
export const logoContainer = "downloads-module--logo-container--1DE_r";